import { defineComponent as _defineComponent } from 'vue'
import { openBlock as _openBlock, createElementBlock as _createElementBlock } from "vue"

import { useRoute, useRouter } from 'vue-router';
import { onMounted } from 'vue';
import SchoolRoles from '@/common/types/school-roles';
import AuthService from '@/services/AuthService';
import { updateBaseUrl } from '@/http/api';


export default /*#__PURE__*/_defineComponent({
  __name: 'auth-component',
  setup(__props) {

const router = useRouter();
const route = useRoute();

onMounted(() => {
    const domain = route.query.snotra_domain;
    const role = route.query.snotra_role;
    if (
        domain &&
        role &&
        typeof domain === 'string' &&
        typeof role === 'string'
    ) {
        localStorage.setItem('schoolSnotraDomain', domain);
        localStorage.setItem('role', role);
        updateBaseUrl();

        switch (role) {
            case SchoolRoles.Teacher:
                router.push({ name: 'sn.teacher.main' });
                break;
            case SchoolRoles.Student:
                router.push({ name: 'sn.student.main' });
                break;
            default:
                AuthService.logout();
        }
    }
});

return (_ctx: any,_cache: any) => {
  return (_openBlock(), _createElementBlock("div"))
}
}

})